<template>
  <div class="EMS-Part-Type-Main">
    <div>
      <Menus :menu="menu" @menuClicked="menuClicked" />
    </div>
    <div class="EMSPartTypeTable">
      <TableBox
        :tableData="EMSPartTypeList"
        :selectedRow.sync="selectedArea"
        title="EMS Part Type"
        :dataType="columnTypeMain"
      />
    </div>
    <PopupEntry
      :show.sync="popupEntryShow"
      v-if="popupEntryShow"
      :title="popupEntryTitle"
      :createdBy="createdBy"
      :updatedBy="updatedBy"
      @save="saveClicked"
      :requiredError="entryRequired"
      :successMessages="entrySuccess"
      :messages="entryMessages"
      :errorMessages="entryError"
      @requiredClicked="entryRequiredClicked"
      :viewMode="viewMode"
      :cancelButton="viewMode ? 'Close' : 'Cancel'"
    >
      <div class="General Details" style="display: flex; height: 100%">
        <div class="gen-details-right">
          <Input
            :isDisabled="viewModePT"
            placeholder="Part Type"
            :isRequired="true"
            :inputValue.sync="partType"
            :errorMessage.sync="partTypeError"
            ref="part_type"
            validator="masterfilecode,25"
          />
          <Input
            :isDisabled="viewMode"
            placeholder="Description"
            :isRequired="true"
            :inputValue.sync="description"
            :errorMessage.sync="descriptionError"
            ref="descriptionMSG"
            validator="text,100"
          />
          <InputQuery
            :isDisabled="viewMode"
            placeholder="Expenses Code"
            :items="expensesCodeData"
            itemKey="Charges Code"
            :selectedObject.sync="expenseCode"
            descKey="Description"
            ref="expenseCode"
            :errorMessage.sync="expenseCodeError"
          />
          <InputQuery
            :isDisabled="viewMode"
            placeholder="Part Grouping"
            :items="partGroupData"
            itemKey="Part Group"
            :selectedObject.sync="partGroup"
            :allowFreeText="true"
            :search.sync="partGroupSearchInput"
          />
          <Dropdown
            placeholder="Unique Code"
            :isDisabled="viewMode"
            :items="optionsForDropdown"
            :selectedObject.sync="uniqueCode"
            itemKey="label"
          />
          <Dropdown
            placeholder="Is Expense"
            :isDisabled="viewMode"
            :items="optionsForDropdown"
            :selectedObject.sync="isExpense"
            itemKey="label"
          />
          <Input
            :isDisabled="viewMode"
            :placeholder="`Unit Price: ${localCurrency}`"
            :inputValue.sync="unitPrice"
            ref="unit_price"
            :errorMessage.sync="unitPriceError"
            validator="positiveDecimal,14,4"
          />
          <InputQuery
            :isDisabled="viewMode"
            placeholder="Supplier Code"
            :items="supplierCodeData"
            itemKey="Supplier Code"
            :selectedObject.sync="supplierCode"
            descKey="Supplier Name"
            ref="supplierCode"
            :errorMessage.sync="supplierCodeError"
          />
          <CheckBoxV2
            title="Is Active"
            :isDisable="viewMode"
            style="min-width: 50px"
            :isChecked.sync="active"
            :isDisabled="viewMode"
          />
        </div>
      </div>
    </PopupEntry>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  data: function () {
    return {
      //Menu
      menu: [
        {
          title: 'New Part Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: 'MnuNew',
          visible: true,
          enabled: true,
        },
        {
          title: 'Edit Part Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png',
          key: 'MnuEdit',
          visible: true,
          enabled: true,
        },
        {
          title: 'Delete Part Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          key: 'MnuDelete',
          visible: true,
          enabled: true,
        }, //api response logic abit weird ("Hide Delete" instead of "Delete")
        {
          title: 'View Part Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          key: 'MnuQuery',
          visible: true,
          enabled: true,
        },
      ],

      //General Data
      EMSPartTypeList: [], //holds all the information for the table view
      partGroupData: [],
      viewMode: false, //to edit something
      popupEntryShow: false, //to enter a popup
      viewModePT: false, //View mode for part type

      //Inputs Data
      partType: '',
      description: '',
      expenseCode: null,
      partGroup: null,
      partGroupSearchInput: '',
      uniqueCode: null,
      isExpense: null,
      unitPrice: '',
      supplierCode: null,
      active: false,
      optionsForDropdown: [
        {
          label: 'Yes',
          API_VALUE: 'Y',
        },
        {
          label: 'No',
          API_VALUE: 'N',
        },
      ],
      createdBy: '',
      updatedBy: '',
      columnTypeMain: {
        '#': 'number',
        'Unit Price': 'currency',
      },

      //Error
      selectedArea: [], //used to identify selected area of the code
      partTypeError: '',
      descriptionError: '',
      expenseCodeError: '',
      supplierCodeError: '',
      unitPriceError: '',
      entryRequired: [],
      entrySuccess: [],
      entryMessages: [],
      entryError: [],

      localCurrency: 'MYR', //default to MYR, updated after API
    };
  },
  props: {},
  methods: {
    getEMSPartTypeList: async function () {
      this.EMSPartTypeList = [];
      this.$fullscreenLoading('Getting EMS Part Types');
      this.EMSPartTypeList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'EMSPARTTYPE' });
      this.$fullscreenLoading();
    },

    getEMSPartGroup: async function () {
      this.$fullscreenLoading('Getting Part Group');
      this.partGroupData = await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'EMSPARTGROUP' });
      this.$fullscreenLoading();
    },

    menuClicked: async function (e) {
      this.clearAllFields();
      this.clearEntryMessages();

      switch (e.title) {
        case 'View Part Type':
          this.clearEntryMessages();
          if (this.selectedArea.length == 0) {
            this.$showAlert('error', 'No EMS Part Type Selected', 'Please select an EMS Part Type to view');
          } else {
            this.popupEntryShow = true;
            this.$fullscreenLoading('Loading EMS Part Types');
            this.popupEntryTitle = 'View EMS Part Type';
            this.viewMode = true;
            this.viewModePT = true;
            await this.populateViewDetails(this.selectedArea[0]['Part Type']);
            this.$fullscreenLoading();
          }
          break;

        case 'New Part Type':
          this.popupEntryShow = true;
          this.popupEntryTitle = 'New EMS Part Type';
          this.viewMode = false;
          this.viewModePT = false;
          this.updatedBy = '';
          this.createdBy = '';
          break;

        case 'Edit Part Type':
          if (this.selectedArea.length == 0) {
            this.$showAlert('error', 'No EMS Part Type Selected', 'Please select an EMS Part Type to edit');
          } else {
            this.clearEntryMessages();
            this.viewMode = false;
            this.viewModePT = true;
            this.popupEntryShow = true;
            this.popupEntryTitle = 'Edit EMS Part Type';
            await this.populateViewDetails(this.selectedArea[0]['Part Type']);
          }
          break;

        case 'Delete Part Type':
          if (this.selectedArea.length == 0) {
            this.$showAlert('error', 'No EMS Part Type Selected', 'Please select an EMS Part Type to delete');
          } else {
            let deleting = await this.$showAlert(
              'warning',
              'Delete EMS Part Type',
              `Are you sure you want to delete EMS Part Type for ${this.selectedArea[0]['Part Type']}?`,
              [
                { text: 'Delete', textColor: 'white', color: 'red' },
                { text: 'Cancel', textColor: 'black', color: 'lightgray' },
              ],
            );
            if (deleting == 'Delete') {
              let result = await this.$apiCallV2('/EMSPartType/SaveEMSPartType', {
                actionflag: 'D',
                parttype: this.selectedArea[0]['Part Type'],
              });
              if (result[0]['Results'] == 0) {
                // Delete successful
                this.$showAlert(
                  'success',
                  'EMS Part Type Deleted',
                  `Successfully deleted EMS Part Type for ${this.selectedArea[0]['Part Type']}`,
                );
                this.$nextTick(async () => await this.getEMSPartTypeList());
              } else {
                // Delete error
                this.$showAlert(
                  'error',
                  'EMS Part Type NOT Deleted',
                  `There was an error deleting EMS Part Type for ${this.selectedArea[0]['Part Type']}`,
                );
              }
            }
            this.selectedArea = [];
          }
          break;
      }
    },

    populateViewDetails: async function (record) {
      this.$fullscreenLoading('Getting Details');
      let details = (
        await this.$apiCallV2('/Master/GetDetailsMaster', { masterfile: 'EMSPARTTYPE', recordid: record })
      )['EMSPartType'];

      this.partType = this.populateTextTrim(details['PartType']);
      this.description = this.populateTextTrim(details['Description']);
      this.expenseCode = this.populateObject(this.expensesCodeData, 'Charges Code', details['ExpenseCode']);
      this.partGroup = this.populateObject(this.partGroupData, 'Part Group', details['PartGroup']);
      this.uniqueCode = this.populateObject(this.optionsForDropdown, 'API_VALUE', details['UniqueCode']);
      this.isExpense = this.populateObject(this.optionsForDropdown, 'API_VALUE', details['IsExpenses']);
      this.unitPrice = this.populateTextTrim(details['CostPrice']);
      this.supplierCode = this.populateObject(this.supplierCodeData, 'Supplier Code', details['SuppCode']);
      this.active = details['Active'] == '1';

      this.createdBy = `${details['UserCreated'] ? details['UserCreated'] : ''} ${details['DateCreated'] ? new Date(details['DateCreated']).formatString('dd/MM/yyyy HH:mm') : ''}`;
      this.updatedBy = `${details['UserID'].trim() ? details['UserID'].trim() : ''} ${details['DateUpdated'] ? new Date(details['DateUpdated']).formatString('dd/MM/yyyy HH:mm') : ''}`;
      this.$fullscreenLoading();
    },

    clearAllFields: function () {
      this.partType = '';
      this.description = '';
      this.expenseCode = null;
      this.partGroup = null;
      this.uniqueCode = null;
      this.isExpense = null;
      this.unitPrice = '';
      this.supplierCode = null;
      this.active = false;
      this.partTypeError = '';
      this.descriptionError = '';
      this.unitPriceError = '';
    },

    populateTextTrim: function (text) {
      // To populate text with trim
      return text ? text.trim() : '';
    },

    populateObject: function (data, key, compare) {
      // To populate object into dropdown or input query
      try {
        return data.find((d) => d[key].trim() == (compare ? compare.trim() : ''));
      } catch (error) {
        return null;
      }
    },

    clearEntryMessages: function () {
      this.entryRequired = [];
      this.entrySuccess = [];
      this.entryMessages = [];
      this.entryError = [];
    },

    checkFields: function () {
      this.clearEntryMessages();
      if (!this.partType || this.partType.trim() === '') {
        this.partTypeError = 'Part Type is required!';
        this.entryRequired.push({ key: 'part_type', value: 'Part Type is required!' });
      } else {
        if (this.partType.length > 25) {
          this.partTypeError = 'Part Type cannot exceed 25 characters!';
          this.entryRequired.push({ key: 'part_type', value: 'Part Type cannot exceed 25 characters!' });
        }
      }
      if (!this.description || this.description.trim() === '') {
        this.descriptionError = 'Description is required!';
        this.entryRequired.push({ key: 'descriptionMSG', value: 'Description is required!' });
      } else {
        if (this.description.length > 100) {
          this.descriptionError = 'Description cannot exceed 100 characters!';
          this.entryRequired.push({ key: 'descriptionMSG', value: 'Description cannot exceed 100 characters!' });
        }
      }
      if (!this.unitPrice.match(/^\d*\.?\d*$/g) && this.unitPrice) {
        this.unitPriceError = 'Unit Price must be a number!';
        this.entryRequired.push({
          key: 'unit_price',
          value: 'Unit Price must be a number! Please make sure input is in money format.',
        });
      } else if (this.unitPrice) {
        const [whole, decimals] = this.unitPrice.split('.');
        if (whole.length > 14) {
          //database: money, prec=19, scale=4; 15 digits, 4 decimals
          this.unitPriceError = 'Unit Price cannot exceed 14 whole digits and 4 decimals!';
          this.entryRequired.push({ key: 'unit_price', value: 'Unit Price cannot exceed 14 Digits and 4 Decimals!' });
        } else if (decimals?.length > 4) {
          this.unitPriceError = 'Unit Price cannot exceed 14 whole digits and 4 decimals!';
          this.entryRequired.push({ key: 'unit_price', value: 'Unit Price cannot exceed 14 Digits and 4 Decimals!' });
        }
      }
      return this.entryRequired.length > 0;
    },

    entryRequiredClicked: function (item) {
      this.$refs[item].setFocus();
    },

    saveClicked: async function () {
      let isNotValid = this.checkFields();
      if (!isNotValid) {
        let action = this.popupEntryTitle[0];
        let dataToPost = {
          parttype: this.partType.toUpperCase().trim(),
          description: this.description.toUpperCase().trim(),
          actionflag: action,
          partgroup: this.partGroup ? this.partGroup['Part Group'] : this.partGroupSearchInput,
          expensecode: this.expenseCode ? this.expenseCode['Charges Code'] : '',
          suppcode: this.supplierCode ? this.supplierCode['Supplier Code'] : '',
          costprice: this.unitPrice,
          active: this.active ? '1' : '0',
          uniquecode: this.uniqueCode && this.uniqueCode.API_VALUE ? this.uniqueCode.API_VALUE : '',
          isexpenses: this.isExpense && this.isExpense.API_VALUE ? this.isExpense.API_VALUE : '',
        };

        this.$fullscreenLoading(dataToPost['Action'] == 'D' ? 'Deleting EMS Part Type' : 'Saving EMS Part Type');

        let result = await this.$apiCallV2('/EMSPartType/SaveEMSPartType', dataToPost);
        this.$nextTick(async () => await this.getEMSPartTypeList());
        this.$fullscreenLoading();

        if (result[0]['Results'] == 0) {
          // Save successful
          if (action == 'N') {
            this.entrySuccess.push(`Successfully created EMS Part Type for ${this.partType}`);
          } else {
            this.entrySuccess.push(`Successfully edited EMS Part Type for ${this.partType}`);
          }
          this.getEMSPartGroup();
          this.viewMode = true;
          this.viewModePT = true;
        } else {
          // Save error
          if (action == 'N') {
            this.entryError.push(`There was an error creating EMS Part Type: ${result[0]['ErrMsg']}`);
          } else {
            this.entryError.push(`There was an error editing EMS Part Type: ${result[0]['ErrMsg']}`);
          }
        }
      }
    },

    getLocalCurrency: async function () {
      const companyDetails = await this.$apiCallV2('/Master/GetDetailsMaster', {
        masterfile: 'COMPANY',
        module: 'MASTER',
        recordid: this.$store.state.loginDetails.CoCode,
      });
      if (companyDetails.CompanyLocalCur) this.localCurrency = companyDetails.CompanyLocalCur;
    },
  },
  async mounted() {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'EMS Part Type') {
        x.data.forEach((k) => {
          //key in menu same as control value from api
          let selectedMenu = this.menu.find((m) => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
          }
        });
      }
    });

    this.$fullscreenLoading('Getting EMSPartType List');
    this.EMSPartTypeList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'EMSPARTTYPE' });
    this.$fullscreenLoading();

    this.$fullscreenLoading('Getting Expense Code');
    this.expensesCodeData = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'EXPENSECODE' });
    this.$fullscreenLoading();

    this.getEMSPartGroup();

    this.$fullscreenLoading('Getting Supplier Code');
    this.supplierCodeData = await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'SUPPLIER' });
    this.$fullscreenLoading();

    this.getLocalCurrency();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.EMS-Part-Type-Main {
  font-size: 12px;
  width: 100%;
  height: 100%;
  padding: 10px 45px;
  display: flex;

  .EMSPartTypeTable {
    width: 100%;
    margin-left: 5px;
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    display: flex;
    overflow: hidden;
  }
}

.gen-details-right {
  display: flex;
  flex-direction: column;
  width: 100%;
}
</style>
